const STORAGE_KEY = 'proyectos_login_remember';

export type LoginRememberData = {
  username: string;
  password: string;
  remember: boolean;
};

function decodeStored(value: string): string {
  try {
    return atob(value);
  } catch {
    return '';
  }
}

function encodeStored(value: string): string {
  try {
    return btoa(value);
  } catch {
    return '';
  }
}

/** Credenciales guardadas en este equipo (solo si el usuario marcó Recuérdame). */
export function loadLoginRemember(): LoginRememberData {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { username: '', password: '', remember: false };
    const parsed = JSON.parse(raw);
    if (!parsed?.remember) return { username: '', password: '', remember: false };
    return {
      username: decodeStored(String(parsed.username || '')),
      password: decodeStored(String(parsed.password || '')),
      remember: true,
    };
  } catch {
    return { username: '', password: '', remember: false };
  }
}

export function saveLoginRemember(username: string, password: string): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      remember: true,
      username: encodeStored(username),
      password: encodeStored(password),
    }),
  );
}

export function clearLoginRemember(): void {
  localStorage.removeItem(STORAGE_KEY);
}

/** Cierra sesión sin borrar «Recuérdame». */
export function clearAuthSession(): void {
  ['authToken', 'user', 'CargoId', 'Role'].forEach((key) => localStorage.removeItem(key));
}
